export default __webpack_public_path__ + "static/media/qr-promptpay.fad5c96a.svg";